import {
  TICKET_STATUS_LABELS,
  UNIT_STATUS_LABELS,
  USER_STATUS_LABELS,
  type TicketStatus,
  type UnitStatus,
  type UserStatus,
} from '@sf/shared';
import { cn } from '../lib/cn';

type Tone = 'amber' | 'green' | 'red' | 'blue' | 'gray';

const tones: Record<Tone, { pill: string; dot: string }> = {
  amber: { pill: 'bg-sunrise-50 text-sunrise-700', dot: 'bg-sunrise' },
  green: { pill: 'bg-valley-50 text-valley-700', dot: 'bg-valley' },
  red: { pill: 'bg-danger-50 text-danger-700', dot: 'bg-danger-700' },
  blue: { pill: 'bg-brand-50 text-brand-700', dot: 'bg-brand-light' },
  gray: { pill: 'bg-gray-100 text-slate', dot: 'bg-slate' },
};

const userTone: Record<UserStatus, Tone> = {
  pending: 'amber',
  active: 'green',
  deactivated: 'red',
};
const ticketTone: Record<TicketStatus, Tone> = {
  open: 'blue',
  in_progress: 'amber',
  resolved: 'green',
  closed: 'gray',
};
const unitTone: Record<UnitStatus, Tone> = { occupied: 'blue', vacant: 'green' };

type Props =
  | { kind: 'user'; value: UserStatus }
  | { kind: 'ticket'; value: TicketStatus }
  | { kind: 'unit'; value: UnitStatus };

export function StatusBadge(props: Props & { className?: string }) {
  let tone: Tone;
  let label: string;
  if (props.kind === 'user') {
    tone = userTone[props.value];
    label = USER_STATUS_LABELS[props.value];
  } else if (props.kind === 'ticket') {
    tone = ticketTone[props.value];
    label = TICKET_STATUS_LABELS[props.value];
  } else {
    tone = unitTone[props.value];
    label = UNIT_STATUS_LABELS[props.value];
  }
  return (
    <span
      data-tone={tone}
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold',
        tones[tone].pill,
        props.className,
      )}
    >
      <span aria-hidden className={cn('size-1.5 rounded-full', tones[tone].dot)} />
      {label}
    </span>
  );
}
